module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("Crimes reverberate through years and through lives. It is a rare homicide that destroys only one person.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("Joyce Carol Oates, ‘After Black Rock’")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("Most gypsies fear the dead.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("Raymond Buckland, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Buckland’s Book of Gypsy"), _c('br'), _vm._v("Magic – Travellers’ Stories,"), _c('br'), _vm._v("Spells & Healings")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0